import React from 'react';

// import VisuallyHidden from '@reach/visually-hidden';
// import '@reach/dialog/styles.css';
// import iconClose from '../../assets/close.svg';
import modalCedula from '../../assets/modal-cedula.png';
import { breakpoints, colors } from '../config';

const ModalCedula = ({ onDismiss, children, onEditFinish }) => {
  React.useEffect(() => {
    document.querySelector('#confirma-cedula').focus();

    document.querySelector('reach-portal').addEventListener('click', e => {
      if (document.querySelector('.edit-wrapper').contains(e.target)) {
        // Clicked in box
        // alert('click adentro');
      } else {
        // alert('click outside');
        onEditFinish && onEditFinish();
        // Clicked outside the box
      }
    });
  }, []);

  return (
    <div className="modal-inner">
      <div className="modal-body">
        <div className="image-wrapper">
          <img className="image" src={modalCedula} alt="" />
        </div>
        <div className="title">¿Seguro/a que esta es tu cédula?</div>
        {children}
      </div>

      <style jsx>{`
        .modal-body {
          padding: 24px;
        }
        .image-wrapper {
          text-align: center;
          margin-bottom: 1rem;
        }
        .image {
          margin-left: 24px;
          width: 180px;
          height: auto;
        }
        .title {
          font-family: 'ItauDisplay', sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          line-height: 26px;
          text-align: center;
          color: #252220;
          margin-bottom: 1rem;
        }

        @media (max-width: 992px) {
          .title {
            font-size: 18px;
          }
        }
      `}</style>

      <style jsx>{`
        :global(reach-portal :focus) {
          outline: 0 !important;
        }

        :global(reach-portal a) {
          color: ${colors.orange};
          text-decoration: none;
        }

        :global(reach-portal p) {
          margin-bottom: 10px;
        }

        :global([data-reach-dialog-overlay]) {
          align-items: center;
          display: flex;
          overflow: hidden;
          z-index: 9999;
        }

        :global([data-reach-dialog-content]) {
          background: transparent;
          margin: 0 auto;
          padding: 0 !important;
          border-radius: ${colors.borderRadius};
          max-width: 327px !important;
        }

        @media screen and (max-width: ${breakpoints.md}) {
          :global([data-reach-dialog-content]) {
            width: 90vw !important;
          }
        }

        .modal-inner {
          background-color: ${colors.white};
          border-radius: ${colors.borderRadius};
          max-height: 80vh;
          overflow: hidden;
          position: relative;
        }

        .close-button {
          background: transparent;
          border: 0;
          cursor: pointer;
          font-family: inherit;
          margin: 0;
          padding: 0;
          position: absolute;
          right: 16px;
          top: 16px;
        }
      `}</style>
    </div>
  );
};

export default ModalCedula;
